import {Fragment} from "react";
import {Button} from "@mui/material";
import SaveDialog from "./SaveDialog";
import {useBoolState} from "../../../../../hooks";
import {defineMessage, FormattedMessage} from "react-intl";
import {SaveThirdPartyDeviceMutationVariables} from "../../queries.generated";

type Props = {
    extensionId: number;
    onSuccess: () => void;
    disabled: boolean;
};

export default ({extensionId, onSuccess, disabled}: Props) => {
    const [isOpen, open, close] = useBoolState();
    const initialData: SaveThirdPartyDeviceMutationVariables = {
        userId: extensionId,
        description: "",
        sipPassword: "",
        sipUser: "",
    };

    return (
        <Fragment>
            <Button
                disabled={disabled}
                color="primary"
                size="small"
                onClick={open}
                variant="contained"
                id="create-thirdparty-device"
            >
                <FormattedMessage id="devices.third_party.create" defaultMessage="Create third-party device" />
            </Button>
            <SaveDialog
                isOpen={isOpen}
                close={close}
                title={defineMessage({id: "devices.third_party.create", defaultMessage: "Create third-party device"})}
                initialData={initialData}
                onSuccess={onSuccess}
                cacheKeyPostfix="create"
            />
        </Fragment>
    );
};
